<!-- Trigger button lives OUTSIDE usually, but many teams prefer it inside.
     We'll keep it here to make the component self-contained. -->
<button class="btn btn-outline btn-default dt-download" matTooltip="Sorting" [matMenuTriggerFor]="sortingMenu">
    <mat-icon class="text-primary hover:text-white" svgIcon="mat_outline:sort"></mat-icon>
</button>

<mat-menu #sortingMenu="matMenu" [overlapTrigger]="false" class="max-w-[400px]">
    <!-- STOP CLICKS so menu stays open -->
    <div class="px-3 py-2 w-[400px]" (click)="$event.stopPropagation();" (keydown)="$event.stopPropagation()"
        [formGroup]="form">
        <span class="flex justify-center items-center font-semibold text-gray-400 mb-2">Sorting</span>

        <div class="grid grid-cols-2" formArrayName="SortColumns">
            <div *ngFor="let group of sortColumns.controls; let i = index" [formGroupName]="i">
                <mat-checkbox formControlName="isChecked" (change)="onToggle(group.value, $event.checked)">
                    {{ group.value.name }} <b>{{ getSortSequence(group.value.key) }}</b>
                </mat-checkbox>
            </div>
        </div>

        <div class="divider my-2"></div>

        <mat-radio-group formControlName="OrderDir" class="grid grid-cols-2">
            <mat-radio-button [value]="'asc'" class="block mb-2">Ascending</mat-radio-button>
            <mat-radio-button [value]="'desc'" class="block mb-2">Descending</mat-radio-button>
        </mat-radio-group>

        <div class="mt-2 flex justify-center gap-8">
            <button mat-stroked-button color="primary" (click)="$event.stopPropagation(); applySort()">Apply</button>
            <button mat-button class="text-gray-400" (click)="$event.stopPropagation(); clearSort()">Clear</button>
        </div>
    </div>
</mat-menu>